const washingMachineDetailedRateCard = {
  key: "washing-machine",
  title: "Washing Machine Detailed Rate Card",
  note:
    "Indicative washing machine pricing. Final price depends on machine type, part replacement, drum condition, and service complexity.",
  sections: [
    {
      title: "Inspection",
      items: [
        { name: "Machine inspection", price: "₹249 visit" },
      ],
    },
    {
      title: "Installation",
      items: [
        { name: "Washing machine installation", price: "₹499 onwards" },
        { name: "Washing machine uninstallation", price: "₹349" },
      ],
    },
    {
      title: "Repair Support",
      items: [
        { name: "Drainage / water outlet issue", price: "₹399 onwards" },
        { name: "Spin / vibration issue", price: "₹399 onwards" },
        { name: "Inlet / hose-related issue", price: "₹299 onwards" },
      ],
    },
  ],
};

export default washingMachineDetailedRateCard;